<template>
    <div class="bg">
        <div class="title" v-if="item">
            <img @click="back" class="back" src="@/assets/theme/light/status/01dailyActive/01back.svg">
            <img @click="share" class="share-icon" src="@/assets/theme/light/report/03month/03share.png">
            <img @click="toHistory" class="history-icon" src="@/assets/theme/light/report/03month/04history.png">
        </div>
        <div class="title-none" v-if="!item">
            <img @click="back" class="back" src="@/assets/theme/light/status/01dailyActive/01back.svg">
            <img @click="toHistory" class="history-icon" src="@/assets/theme/light/report/03month/04history.png">
        </div>
        <div :class="$i18n.locale == 'en' ? 'content-en' : 'content' " v-if="item">
            <div class="head-box">
                <img class="user-img" :src="item.userAvatar? item.userAvatar : defaultImg">
                <div class="user-name">{{ item.userName }}</div>
                <div class="time-range">
                    {{ item.weeklyBegin.slice(5, 10).replace(/-/g, '/') }}-{{ item.weeklyEnd.slice(5, 10).replace(/-/g, '/') }}
                </div>
            </div>
            <div class="step-box">
                <div class="step-total value-font">{{ format(item.weeklySteps) }}
                    <span class="unit"v-if="item.weeklySteps==1">{{$t('unit.step')}}</span>
                    <span class="unit"v-if="item.weeklySteps>1">{{$t('unit.steps')}}</span>
                </div>
                <img v-if="item.stepsVariation == 0" class="step-icon-flat" src="@/assets/report/weekly/flat.png">
                <img v-if="item.stepsVariation > 0" class="step-icon" src="@/assets/report/weekly/up.png">
                <img v-if="item.stepsVariation < 0" class="step-icon" src="@/assets/report/weekly/down.png">
                <div class="steps-variation value-font">{{ format(Math.abs(item.stepsVariation)) }}
                    <span class="unit" v-if="Math.abs(item.stepsVariation)==1">{{ $t('unit.step') }}</span>
                    <span class="unit" v-if="Math.abs(item.stepsVariation)>1">{{ $t('unit.steps') }}</span>
                </div>
                <div class="step-daily" id="step"></div>
                <div class="step-compliance value-font">{{ item.stepDayCompliance }}
                    <span class="unit" v-if="item.stepDayCompliance==1">{{ $t('unit.day') }}</span>
                    <span class="unit" v-if="item.stepDayCompliance>1">{{ $t('unit.days') }}</span>
                </div>
                <div class="percent">
                    <van-progress :percentage="item.stepsRatio * 100" stroke-width="9" track-color="#F3F3F3"
                                  color="var(--chart-color-1)"/>
                </div>
                <div class="percent-text">{{ $t('newWeek.stepDesc0') }}<span
                    class="steps-ratio">{{ parseInt(item.stepsRatio * 100) + '%' }}</span>{{ $t('newWeek.stepDesc1') }}
                </div>
            </div>
            <div class="sport-box">
                <div class="sport-num value-font">{{ item.sportNumber }}
                    <span class="unit" v-if="item.sportNumber==1">{{$t('unit.time')}}</span>
                    <span class="unit" v-if="item.sportNumber>1">{{ $t('unit.times')}}</span>
                </div>
                <img v-if="item.sportNumberVariation == 0" class="sport-num-icon-flat"
                     src="@/assets/report/weekly/flat.png">
                <img v-if="item.sportNumberVariation > 0" class="sport-num-icon" src="@/assets/report/weekly/up.png">
                <img v-if="item.sportNumberVariation < 0" class="sport-num-icon" src="@/assets/report/weekly/down.png">
                <div class="sport-num-variation value-font">{{ Math.abs(item.sportNumberVariation) }}
                    <span class="unit" v-if="Math.abs(item.sportNumberVariation)==1">{{ $t('unit.time') }}</span>
                    <span class="unit" v-if="Math.abs(item.sportNumberVariation)>1">{{ $t('unit.times') }}</span>
                </div>
                <div class="mileage value-font">{{ (item.mileage / 100000).toFixed(2) }} <span
                    class="unit">{{ $t('unit.km') }}</span></div>
                <img v-if="item.mileageVariation == 0" class="mileage-icon-flat" src="@/assets/report/weekly/flat.png">
                <img v-if="item.mileageVariation > 0" class="mileage-icon" src="@/assets/report/weekly/up.png">
                <img v-if="item.mileageVariation < 0" class="mileage-icon" src="@/assets/report/weekly/down.png">
                <div class="mileage-variation value-font">
                    {{ Math.abs((item.mileageVariation / 100000).toFixed(2)) }} <span
                    class="unit">{{ $t('unit.km') }}</span></div>
                <div class="duration value-font">{{ (item.duration / 3600).toFixed(2) }}
                    <span class="unit" v-if="(item.duration / 3600).toFixed(2)==1">{{$t('unit.hour') }}</span>
                    <span class="unit" v-if="(item.duration / 3600).toFixed(2)>1">{{$t('unit.hours') }}</span>
                </div>
                <img v-if="item.durationVariation == 0" class="duration-icon-flat"
                     src="@/assets/report/weekly/flat.png">
                <img v-if="item.durationVariation > 0" class="duration-icon" src="@/assets/report/weekly/up.png">
                <img v-if="item.durationVariation < 0" class="duration-icon" src="@/assets/report/weekly/down.png">
                <div class="duration-variation value-font">{{Math.abs((item.durationVariation / 3600).toFixed(2)) }}
                    <span class="unit" v-if="Math.abs((item.durationVariation / 3600).toFixed(2)) == 1">{{ $t('unit.hour') }}</span>
                    <span class="unit" v-if="Math.abs((item.durationVariation / 3600).toFixed(2)) > 1">{{ $t('unit.hours') }}</span>
                </div>
                <div class="ratio-box">
                    <div class="sport-ratio-box">
                        <div class="sport-1 line" :style="{'width': sportWidth1 + 'px'}"></div>
                        <div class="sport-2 line two" :style="{'width': sportWidth2 + 'px'}"></div>
                        <div class="sport-3 line three" :style="{'width': sportWidth3 + 'px'}"></div>
                        <div class="sport-4 line" :style="{'width': sportWidth4 + 'px'}"></div>
                    </div>
                    <van-row>
                        <van-col span="6">
                            <div class="bar-box">
                                <div class="sport-1 bar"></div>
                                <span class="bar-text"
                                      :class="{ 'bar-text-en': $i18n.locale == 'en' }">{{
                                        getLangSportType(item.weeklyDuration[0].type)
                                    }}</span>
                                <div class="bar-value">{{ (item.weeklyDuration[0].value * 100).toFixed(2) }}%</div>
                            </div>
                        </van-col>
                        <van-col span="6">
                            <div class="bar-box">
                                <div class="sport-2 bar"></div>
                                <span class="bar-text"
                                      :class="{ 'bar-text-en': $i18n.locale == 'en' }">{{
                                        getLangSportType(item.weeklyDuration[1].type)
                                    }}</span>
                                <div class="bar-value">{{ (item.weeklyDuration[1].value * 100).toFixed(2) }}%</div>
                            </div>
                        </van-col>
                        <van-col span="6">
                            <div class="bar-box">
                                <div class="sport-3 bar"></div>
                                <span class="bar-text"
                                      :class="{ 'bar-text-en': $i18n.locale == 'en' }">{{
                                        getLangSportType(item.weeklyDuration[2].type)
                                    }}</span>
                                <div class="bar-value">{{ (item.weeklyDuration[2].value * 100).toFixed(2) }}%</div>
                            </div>
                        </van-col>
                        <van-col span="6">
                            <div class="bar-box">
                                <div class="sport-4 bar"></div>
                                <span class="bar-text"
                                      :class="{ 'bar-text-en': $i18n.locale == 'en' }">{{
                                        getLangSportType(item.weeklyDuration[3].type)
                                    }}</span>
                                <div class="bar-value">{{ (item.weeklyDuration[3].value * 100).toFixed(2) }}%</div>
                            </div>
                        </van-col>
                    </van-row>
                </div>
            </div>
            <div class="cal-box">
                <div class="cal value-font">{{ format(parseInt(item.calorie / 1000)) }} <span
                    class="unit">{{ $t('unit.kcal') }}</span></div>
                <img v-if="item.calorieVariation == 0" class="cal-icon-flat" src="@/assets/report/weekly/flat.png">
                <img v-if="item.calorieVariation > 0" class="cal-icon" src="@/assets/report/weekly/up.png">
                <img v-if="item.calorieVariation < 0" class="cal-icon" src="@/assets/report/weekly/down.png">
                <div class="cal-variation value-font">
                    {{ format(Math.abs(parseInt(item.calorieVariation / 1000))) }} <span
                    class="unit">{{ $t('unit.kcal') }}</span></div>
                <div class="cal-daily" id="cal"></div>
                <div class="cal-compliance value-font">{{ item.calorieDayCompliance }}
                    <span class="unit"v-if="item.calorieDayCompliance==1">{{$t('unit.day')}}</span>
                    <span class="unit"v-if="item.calorieDayCompliance>1">{{$t('unit.days')}}</span>
                </div>
                <div class="ratio-box-2">
                    <div class="sport-ratio-box">
                        <div class="cal-1 line" :style="{'width': calWidth1 + 'px'}"></div>
                        <div class="cal-2 line two" :style="{'width': calWidth2 + 'px'}"></div>
                        <div class="cal-3 line three" :style="{'width': calWidth3 + 'px'}"></div>
                        <div class="cal-4 line" :style="{'width': calWidth4 + 'px'}"></div>
                    </div>
                    <van-row>
                        <van-col span="6">
                            <div class="bar-box">
                                <div class="cal-1 bar"></div>
                                <span class="bar-text"
                                      :class="{ 'bar-text-en': $i18n.locale == 'en' }">{{
                                        getLangSportType(item.weeklyCalories[0].type)
                                    }}</span>
                                <div class="bar-value">{{ (item.weeklyCalories[0].value * 100).toFixed(2) }}%</div>
                            </div>
                        </van-col>
                        <van-col span="6">
                            <div class="bar-box">
                                <div class="cal-2 bar"></div>
                                <span class="bar-text"
                                      :class="{ 'bar-text-en': $i18n.locale == 'en' }">{{
                                        getLangSportType(item.weeklyCalories[1].type)
                                    }}</span>
                                <div class="bar-value">{{ (item.weeklyCalories[1].value * 100).toFixed(2) }}%</div>
                            </div>
                        </van-col>
                        <van-col span="6">
                            <div class="bar-box">
                                <div class="cal-3 bar"></div>
                                <span class="bar-text"
                                      :class="{ 'bar-text-en': $i18n.locale == 'en' }">{{
                                        getLangSportType(item.weeklyCalories[2].type)
                                    }}</span>
                                <div class="bar-value">{{ (item.weeklyCalories[2].value * 100).toFixed(2) }}%</div>
                            </div>
                        </van-col>
                        <van-col span="6">
                            <div class="bar-box">
                                <div class="cal-4 bar"></div>
                                <span class="bar-text"
                                      :class="{ 'bar-text-en': $i18n.locale == 'en' }">{{
                                        getLangSportType(item.weeklyCalories[3].type)
                                    }}</span>
                                <div class="bar-value">{{ (item.weeklyCalories[3].value * 100).toFixed(2) }}%</div>
                            </div>
                        </van-col>
                    </van-row>
                </div>
            </div>
        </div>
        <div class="no-content" v-if="!item">
            <img class="no-icon" src="@/assets/theme/light/report/03month/05no.png">
            <div class="no-time-range">
                <div>{{ startDate }} - {{ endDate }}</div>
                <div>{{ $t('noData') }}</div>
            </div>
        </div>
    </div>
</template>

<script>
import {getNWeekFirstDay, getNWeekLastDay} from '@/utils/dateUtils'
import {format} from '@/utils/math'
import {getQueryVariable, getSkin} from '@/utils/comment'
import {WebJSBridge} from "../../utils/JSBridge1";

export default {
    name: 'weekly',
    data() {
        return {
            theme: 'light',
            defaultImg: require('@/assets/share/home/noImg.png'),
            item: {},
            sportWidth1: 0,
            sportWidth2: 0,
            sportWidth3: 0,
            sportWidth4: 0,
            calWidth1: 0,
            calWidth2: 0,
            calWidth3: 0,
            calWidth4: 0,
            startDate: getQueryVariable('startDate'),
            endDate: getQueryVariable('endDate'),
        }
    },
    mounted() {
        if (this.$route.query.theme) {
            this.theme = this.$route.query.theme
        }
        if (this.$route.query.token) {
            localStorage.setItem("token", this.$route.query.token);
        }
        if (!this.startDate) {
            this.startDate = this.noFormat(getNWeekFirstDay(-1));
            this.endDate = this.noFormat(getNWeekLastDay(-1));
        } else {
            this.startDate = this.noFormat(this.startDate);
            this.endDate = this.noFormat(this.endDate);
        }
        this.getSportWeeklyDes();
    },
    methods: {
        back() {
            this.$router.back();
        },
        share() {
            WebJSBridge.call("shareReport", null, function (res) {
                console.log("recieve callback")
                console.log(res)
            });
        },
        toHistory() {
            this.$router.push({
                name: 'newWeekHistory',
                query: {
                    lang: this.$i18n.locale,
                    theme: this.theme
                }
            })
        },
        getSportWeeklyDes() {
            this.$api.report.getSportWeeklyDes({
                startDate: getQueryVariable('startDate')
            }).then(res => {
                this.item = res.info;
                let ratio = document.body.clientWidth / 375;
                this.item.weeklyDuration = JSON.parse(this.item.weeklyDuration);
                this.item.weeklyCalories = JSON.parse(this.item.weeklyCalories);
                this.sportWidth1 = 265 * ratio * this.item.weeklyDuration[0].value;
                this.sportWidth2 = 265 * ratio * this.item.weeklyDuration[1].value;
                this.sportWidth3 = 265 * ratio * this.item.weeklyDuration[2].value;
                this.sportWidth4 = 265 * ratio * this.item.weeklyDuration[3].value;
                this.calWidth1 = 265 * ratio * this.item.weeklyCalories[0].value;
                this.calWidth2 = 265 * ratio * this.item.weeklyCalories[1].value;
                this.calWidth3 = 265 * ratio * this.item.weeklyCalories[2].value;
                this.calWidth4 = 265 * ratio * this.item.weeklyCalories[3].value;
                let dayStep = JSON.parse(res.info.dayStep);
                let dayCalorie = JSON.parse(res.info.dayCalorie);
                this.$nextTick(function () {
                    this.drawChart('step', dayStep, getSkin('--chart-color-1'));
                    this.drawChart('cal', dayCalorie, '#FF7347');
                })
            })

        },
        noFormat(d) {
            let date = new Date(d);
            var y = date.getFullYear()
            var m = date.getMonth() + 1
            var d = date.getDate()
            return y + '/' + m + '/' + d
        },
        format(n) {
            return format(n);
        },
        drawChart(id, odata, color) {
            let data = [];
            for (let i = 0; i < odata.length; i++) {
                if (id == 'cal') {
                    data.push(odata[i].value / 1000)
                } else {
                    data.push(odata[i].value)
                }

            }
            let myChart = this.$echarts.init(document.getElementById(id), null, {renderer: 'svg'});
            myChart.setOption({
                grid: {
                    top: 15,
                    bottom: 0,
                    left: 10,
                    right: 50
                },
                xAxis: {
                    type: 'category',
                    axisLine: {
                        show: false,
                    },
                    axisLabel: {
                        show: false
                    },
                    axisTick: {
                        show: false
                    },
                    splitLine: {
                        show: false
                    },
                    data: ['1', '2', '3', '4', '5', '6', '7']
                },
                yAxis: {
                    type: 'value',
                    position: 'right',
                    axisLabel: {
                        show: false
                    },
                    splitLine: {
                        show: false
                    }
                },
                series: [
                    {
                        data: data,
                        type: 'bar',
                        lineStyle: {
                            width: 3
                        },
                        barWidth: 8,
                        itemStyle: {
                            // 柱形图圆角，鼠标移上去效果，如果只是一个数字则说明四个参数全部设置为那么多
                            normal: {
                                // 柱形图圆角，初始化效果
                                barBorderRadius: [15, 15, 0, 0],
                                //color配置字体的颜色
                                color: function (params) {
                                    var index_color = params.value;
                                    if (index_color === Math.max.apply(null, data)) {//Math.max.apply获取数据源中的的最大值
                                        return color;//Echarts的渐变色设置
                                    } else {
                                        return '#B8B8B8'
                                    }
                                },
                            }
                        },
                        markPoint: {
                            symbolSize: [0, 8], // 容器大小
                            symbolOffset: [0, -5], //位置偏移
                            data: [
                                {type: 'max', name: '最大值'},
                            ],
                            label: {
                                offset: [0, 0],
                                textStyle: {
                                    color: color,
                                },
                                formatter: function (e) {
                                    return format(parseInt(e.value));
                                }
                            },
                        },
                        markLine: {
                            symbol: "none",
                            data: [
                                {
                                    type: "average",
                                    name: "平均值",
                                    symbol: "none",
                                    silent: false,
                                    lineStyle: { // 警戒线样式
                                        color: '#000000'
                                    },
                                    label: {
                                        color: '#000000',
                                        formatter: function (e) {
                                            return format(parseInt(e.value));
                                        }
                                    },
                                }
                            ]
                        }
                    }
                ]
            }, true);
        },
        getLangSportType(item) {
            if (item == '游泳') item = '室内游泳'
            return this.$t('sportType.' + item);
        },
    }
}
</script>

<style scoped>
@import "../../assets/font/font.css";

.bg {
    background-color: #ffffff;
}

.title {
    background: url("~@/assets/theme/light/report/02week/01bg1.png");
    background-size: 375px;
    width: 375px;
    height: 88px;
    position: relative;
}

.title-none {
    width: 375px;
    height: 88px;
    position: relative;
}

.back {
    width: 22px;
    height: 22px;
    position: absolute;
    left: 15px;
    top: 55px;
}

.share-icon {
    position: absolute;
    width: 22px;
    height: 22px;
    top: 55px;
    right: 47px;
}

.history-icon {
    position: absolute;
    width: 22px;
    height: 22px;
    top: 55px;
    right: 15px;
}

.content {
    background: url("~@/assets/theme/light/report/02week/02bg2.png");
    background-size: 375px;
    width: 375px;
    height: 1060px;
    position: relative;
    padding-top: 0;
}

.content-en {
    background: url("~@/assets/theme/light/report/02week/02bg2en.png");
    background-size: 375px;
    width: 375px;
    height: 1060px;
    position: relative;
    padding-top: 0;
}

.value-font {
    font-size: 30px;
    position: absolute;
    font-family: Bold;
    letter-spacing: 1px;
    color: #000000;
}

.user-img {
    width: 33px;
    height: 33px;
    background: #FFFFFF;
    opacity: 1;
    border: 2px solid rgba(255, 255, 255, 0.69);
    border-radius: 50%;
    position: absolute;
    top: 8px;
    left: 26px;
}

.user-name {
    font-weight: bold;
    color: #000000;
    font-size: 14px;
    position: absolute;
    top: 9px;
    left: 69px;
}

.time-range {
    color: #000000;
    font-size: 12px;
    position: absolute;
    left: 69px;
    top: 28px;
}

.step-total {
    position: absolute;
    left: 51px;
    top: 158px;
}

.unit {
    font-size: 12px;
    color: #666666;
}

.step-icon-flat {
    position: absolute;
    width: 13px;
    left: 226px;
    top: 176px;
}

.step-icon {
    position: absolute;
    width: 13px;
    left: 226px;
    top: 169px;
}

.steps-variation {
    left: 244px;
    top: 158px;
}

.step-daily {
    width: 200px;
    height: 70px;
    position: absolute;
    top: 210px;
    left: 40px;
}

.step-compliance {
    color: #00BD9B;
    left: 244px;
    top: 242px;
}

.percent {
    position: absolute;
    left: 48px;
    top: 311px;
    width: 128px;
}

/deep/ .van-progress__pivot {
    display: none !important;
}

.percent-text {
    position: absolute;
    left: 190px;
    top: 303px;
    font-size: 12px;
    color: #000000;
}

.steps-ratio {
    color: #00BD9B;
    font-size: 17px;
    font-family: bold;
    letter-spacing: 1px;
    margin: 0 2px;
}

.sport-num {
    top: 404px;
    left: 51px;
}

.sport-num-icon-flat {
    position: absolute;
    left: 226px;
    top: 422px;
    width: 13px;
}

.sport-num-icon {
    position: absolute;
    left: 226px;
    top: 415px;
    width: 13px;
}

.sport-num-variation {
    left: 244px;
    top: 404px;
}

.mileage {
    left: 51px;
    top: 480px;
}

.mileage-icon-flat {
    position: absolute;
    left: 226px;
    top: 498px;
    width: 13px;
}

.mileage-icon {
    position: absolute;
    left: 226px;
    top: 491px;
    width: 13px;
}

.mileage-variation {
    left: 244px;
    top: 480px;
}

.duration {
    left: 51px;
    top: 571px;
}

.duration-icon-flat {
    position: absolute;
    width: 13px;
    left: 226px;
    top: 588px;
}

.duration-icon {
    position: absolute;
    width: 13px;
    left: 226px;
    top: 581px;
}

.duration-variation {
    left: 244px;
    top: 571px;
}

.cal {
    left: 126px;
    top: 796px;
}

.cal-icon-flat {
    position: absolute;
    width: 13px;
    left: 237px;
    top: 814px;
}

.cal-icon {
    position: absolute;
    width: 13px;
    left: 237px;
    top: 807px;
}

.cal-variation {
    left: 255px;
    top: 796px;
}

.cal-daily {
    width: 200px;
    height: 70px;
    position: absolute;
    top: 860px;
    left: 40px;
}

.cal-compliance {
    color: #FF7347;
    left: 265px;
    top: 892px;
}

.ratio-box {
    width: 279px;
    position: absolute;
    left: 48px;
    top: 624px;
    height: 20px;
    font-size: 0;
}

.sport-ratio-box {
    margin-bottom: 15px;
}

.line {
    display: inline-block;
    height: 9px;
    border-radius: 2px 2px 2px 2px;
}

.sport-1 {
    background: #00BD9B;
}

.sport-2 {
    background: #30CBEB;
}

.sport-3 {
    background: #2A6BEE;
}

.sport-4 {
    background: #7D4EFF;
}

.bar {
    width: 9px;
    height: 9px;
    border-radius: 2px 2px 2px 2px;
    opacity: 1;
    position: absolute;
    left: 0;
    top: 0;
}

.bar-text {
    font-size: 12px;
    color: #A9B3B3;
    position: absolute;
    top: -4px;
    left: 15px;
}

.bar-text-en {
    width: 54px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.bar-box {
    width: 100%;
    position: relative;
}

.bar-value {
    position: absolute;
    top: 15px;
    left: 15px;
    font-size: 17px;
    font-family: bold;
    color: #000000;
}

.ratio-box-2 {
    width: 279px;
    position: absolute;
    left: 48px;
    top: 960px;
    height: 20px;
    font-size: 0;
}

.cal-1 {
    background: #FF0101;
}

.cal-2 {
    background: #FF9646;
}

.cal-3 {
    background: #FFC231;
}

.cal-4 {
    background: #F1DB1B;
}

.two {
    margin: 0 3px;
}

.three {
    margin-right: 3px;
}

.no-content {
    width: 100%;
    height: 100%;
    position: relative;
}

.no-icon {
    width: 183px;
    position: absolute;
    top: 55px;
    left: 94px;
}

.no-time-range {
    padding-top: 200px;
    text-align: center;
    color: #666666;
    font-size: 15px;
}

.no-time-range div {
    margin-bottom: 9px;
}
</style>



// WEBPACK FOOTER //
// src/views/report/02week.vue